'use client';

import { useForm } from 'react-hook-form';
import { TClinicsPackageSelection } from './clinicsPackageSelection.schema';
import { useAuthState } from '@/app/_providers/store';
import useAuthFunc from '@/hooks/auth/useAuthFunc';
import { useState } from 'react';
import BarLoader from '@/components/ui/loaders/BarLoader';
import { Box, Button, Text } from '@chakra-ui/react';
import ClinicsPackageSelectionForm from './ClinicPackageRequest';
import { clinicPackageCreateRequest } from '@/services/auth/auth.service';
import { toaster } from '@/components/ui';

const PackageSelectionComponent = () => {
   const { handleSubmit } = useForm<TClinicsPackageSelection[]>();
   const { user } = useAuthState();
   const { refreshSession, redirect } = useAuthFunc();
   const [openPackageCreateModal, setOpenPackageCreateModal] = useState(false);
   const [isLoading, setIsLoading] = useState<boolean>(false);
   const [packages, setPackages] = useState<TClinicsPackageSelection[]>([]);

   const onSubmit = handleSubmit(async () => {
      setIsLoading(true);

      const [error, res] = await clinicPackageCreateRequest(packages);
      if (error) {
         console.error(error);
         setIsLoading(false);
         return toaster.error({ title: error.message });
      }

      if (res) {
         setPackages([]);
         await refreshSession();
         redirect('COMPLETED');
      }
      setIsLoading(false);
   });

   const removePackage = (index: number) => {
      const updated = [...packages];
      updated.splice(index, 1);
      setPackages(updated);
   };

   if (!user) {
      return;
   }

   return (
      <>
         {isLoading && <BarLoader loadingText="Verifying" />}
         <div className="flex items-center gap-3">
            {packages.length > 0 && (
               <Box mt={3} mb={3} display="flex" gap={2} flexWrap="wrap">
                  {packages.map((item, index) => (
                     <Box
                        key={index}
                        display="flex"
                        alignItems="center"
                        gap={2}
                        bg="gray.100"
                        px={3}
                        py={1}
                        borderRadius="md"
                     >
                        <Text fontSize="sm" color="black">
                           {item.package_name}
                        </Text>

                        <Button
                           style={{
                              padding: '12px 5px',
                              lineHeight: '0px',
                              height: '20px',
                              fontSize: '15px',
                              width: 'auto',
                              margin: '0px',
                              minWidth: 'auto',
                              borderRadius: '5px',
                           }}
                           size="xs"
                           variant="ghost"
                           color="red.500"
                           onClick={() => removePackage(index)}
                        >
                           ✕
                        </Button>
                     </Box>
                  ))}
               </Box>
            )}

            <Button
               type="button"
               onClick={() => setOpenPackageCreateModal(true)}
               className="px-4 py-2 bg-green-600 text-white rounded-md"
               style={{
                  marginRight: '20px',
               }}
            >
               {!packages.length ? 'Add Package' : 'Add Another Package'}
            </Button>
            <Button
               type="submit"
               className="px-4 py-2 bg-blue-600 text-white rounded-md"
               disabled={packages.length === 0}
               onClick={onSubmit}
            >
               Submit
            </Button>
         </div>
         {openPackageCreateModal && (
            <ClinicsPackageSelectionForm
               isOpen={openPackageCreateModal}
               onClose={() => setOpenPackageCreateModal(false)}
               setPackages={setPackages}
            />
         )}
      </>
   );
};

export default PackageSelectionComponent;
